'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Breakpoints = require('pricing-pages-unified-ui/constants/Breakpoints');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Positioning = _styledComponents2.default.div.withConfig({
  displayName: 'GuaranteeBlob__Positioning'
})(['position:absolute;z-index:-1;top:-60px;@media (max-width:', 'px){display:none;}'], _Breakpoints.GUARANTEE_SECTION);

exports.default = function () {
  return _react2.default.createElement(
    Positioning,
    null,
    _react2.default.createElement(
      'svg',
      {
        width: '1100px',
        viewBox: '0 0 1372 613',
        version: '1.1',
        xmlns: 'http://www.w3.org/2000/svg'
      },
      _react2.default.createElement('path', {
        fill: '#F5F8FA',
        transform: 'translate(-68.000000, -37.000000)',
        d: 'M214.505639,89.27689 C495.098924,-14.8441387 1134.236,49.2342449 1329.70379,170.419485 C1525.17157,291.604725 1453.47233,483.500647 1172.87905,587.621676 C892.285765,691.742705 532.48833,661.062589 319.055466,528.739439 C105.622602,396.416289 -66.087645,193.397919 214.505639,89.27689 Z',
        id: 'bg-blob'
      })
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/GuaranteeBlob.js
// module id = 646
// module chunks = 3 4